// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import TitleWithTooltip from "src/components/shared/text/TitleWithTooltip/TitleWithTooltip";
import Typography from "@mui/material/Typography";
import Alert from "src/components/shared/alerts/Alert/Alert";
import Skeleton from "@mui/material/Skeleton";
import ClinicLanguageDropdown from "../../shared/ClinicLanguageDropdown/ClinicLanguageDropdown";
import PatientLanguageDropdown from "../../shared/PatientLanguageDropdown/PatientLanguageDropdown";

// Styles
import { UI_SIZES } from "src/constants/uiTokens";

// Contexts
import { useClinicSettingsContext } from "src/contexts/clinic/ClinicSettingsContext";

const LanguageSetup = () => {
  const { t } = useTranslation();

  const { currentSettings, handleUpdateSettings, isLoading, isUpdating } =
    useClinicSettingsContext();

  return (
    <Box display="flex" flexDirection="column" gap="12px">
      <Alert
        variant="info"
        alertContent={
          <Typography fontSize="14px">
            {t("New here? Please confirm some settings before continuing.")}
          </Typography>
        }
      />

      <Box display="flex" flexDirection="column" gap="6px">
        <TitleWithTooltip
          title={t("Clinic Default Language")}
          tooltip={t("The language displayed on this site.")}
          titleStyle={{ fontSize: "14px", fontWeight: 600 }}
        />
        {isLoading ? (
          <Skeleton
            variant="rounded"
            width="100%"
            height={UI_SIZES.inputHeight}
            sx={{
              borderRadius: "4px",
            }}
          />
        ) : (
          <ClinicLanguageDropdown
            isDisabled={isUpdating}
            currentSettings={currentSettings}
            handleUpdateSettings={handleUpdateSettings}
          />
        )}
      </Box>
      <Box display="flex" flexDirection="column" gap="6px">
        <TitleWithTooltip
          title={t("Patient Default Language")}
          tooltip={t("The language selected by default on new patients.")}
          titleStyle={{ fontSize: "14px", fontWeight: 600 }}
        />
        {isLoading ? (
          <Skeleton
            variant="rounded"
            width="100%"
            height={UI_SIZES.inputHeight}
            sx={{
              borderRadius: "4px",
            }}
          />
        ) : (
          <PatientLanguageDropdown
            isDisabled={isUpdating}
            currentSettings={currentSettings}
            handleUpdateSettings={handleUpdateSettings}
          />
        )}
      </Box>
    </Box>
  );
};

export default LanguageSetup;
